import { NotificationHandler } from 'mnm-webapp';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from './toaster.service';

@Injectable()
export class ToastrNotificationHandler implements NotificationHandler {
    public constructor(
        private translateService: TranslateService,
        private toasterService: ToasterService
    ) {}

    public notifySuccess(message: string): void {
        this.toasterService.show(
            this.translateService.instant(message),
            'success'
        );
    }

    public notifyInfo(message: string): void {
        this.toasterService.show(
            this.translateService.instant(message),
            'info'
        );
    }

    public notifyWarn(message: string): void {
        this.toasterService.show(
            this.translateService.instant(message),
            'warning'
        );
    }

    public notifyError(message: string): void {
        this.toasterService.show(
            this.translateService.instant(message),
            'error'
        );
    }
}
